import { FA_ICONS } from 'Theme/font-awesome-icon-constants'

export const SOCIAL_NETWORKS = [
  {
    name: 'link_xbox',
    placeholder: 'Xbox',
    icon: FA_ICONS.XBOX,
  },
  {
    name: 'link_youtube',
    placeholder: 'YouTube',
    icon: FA_ICONS.YOUTUBE,
  },
  {
    name: 'link_discord',
    placeholder: 'Discord',
    icon: FA_ICONS.DISCORD,
  },
  {
    name: 'link_twitter',
    placeholder: 'Twitter',
    icon: FA_ICONS.TWITTER,
  },
  {
    name: 'link_twitch',
    placeholder: 'Twitch',
    icon: FA_ICONS.TWITCH,
  },
  {
    name: 'link_facebook',
    placeholder: 'Facebook',
    icon: FA_ICONS.FACEBOOK_F,
  },
  {
    name: 'link_instagram',
    placeholder: 'Instagram',
    icon: FA_ICONS.INSTAGRAM,
  },
  {
    name: 'link_website',
    placeholder: 'Website',
    icon: FA_ICONS.GLOBE,
  },
]
